const hbzwfwJssdk=window.hbzwfwJssdk
// const baseURL ="/api"    //本地开发用
const baseURL ="https://prod-gateway.ehbapp.hubei.gov.cn" //20201229鄂汇办新给的地址,配合X-hbzw-Api-Key鉴权值用（requestHeaderNewWork）

function network(url,reqType,FunMethod,params){
    hbzwfwJssdk.notice.hidePreloader()
    hbzwfwJssdk.notice.showPreloader({
        text: "加载中.."
    })
    hbzwfwJssdk.notice.hidePreloader()
    hbzwfwJssdk.network.request({
        url:baseURL+url,
        type:reqType,
        data:{
            ...params
        },
        headers:{
            'contentType':'application/json',
        },

        success:(res)=>{
            hbzwfwJssdk.notice.hidePreloader()
            FunMethod(res)
            // {
            //     "code":0,
            //     "msg":"成功",
            //     "data":[],
            // }
        },
        fail:(res)=>{
            // FunMethod(res)
      
            hbzwfwJssdk.notice.toast({
                text: res.msg
            })
            hbzwfwJssdk.notice.hidePreloader()
            // {
            //     "code":500,
            //     "msg":"失败",
            //     "data":[],
            // }
        }
    })
}

function requestNetWorkData(url,reqType,params,FunSuccess,FunFail){
    hbzwfwJssdk.notice.hidePreloader()
    hbzwfwJssdk.notice.showPreloader({
        text: "加载中.."
    })
    hbzwfwJssdk.network.request({
        url:baseURL+url,
        type:reqType,
        data:params,
        headers:{
            'contentType':'application/json',
        },
        success:(res)=>{
            hbzwfwJssdk.notice.hidePreloader()
            FunSuccess(res)
        },
        fail:(res)=>{
            // FunMethod(res)
            hbzwfwJssdk.notice.toast({
                text: res.msg
            })
            hbzwfwJssdk.notice.hidePreloader()
            FunFail(res)
        }
    })
    // hbzwfwJssdk.notice.hidePreloader()
}

function requestHeaderNewWork(url,reqType,headers,params,FunSuccess,FunFail){
    hbzwfwJssdk.notice.hidePreloader()
    hbzwfwJssdk.notice.showPreloader({
        text: "加载中.."
    })
    hbzwfwJssdk.network.request({
        url:baseURL+url,
        type:reqType,
        data:params,
        headers:{
            ...headers,
            'Content-Type':'application/json'   
        },
        success:(res)=>{
            hbzwfwJssdk.notice.hidePreloader()
            FunSuccess(res)
        },
        fail:(res)=>{
            hbzwfwJssdk.notice.toast({
                text: res.msg
            })
            hbzwfwJssdk.notice.hidePreloader()
            FunFail(res)
        }
    })
}
export default {network,requestNetWorkData,requestHeaderNewWork}